
export class Address {
    constructor({
                    //attributes
                    id= null,
                    label= '',
                    address= '',
                    number= '',
                    complement= '',
                    district= '',
                    city= '',
                    state= '',
                    zipcode= '',
                    lat= '',
                    long= '',
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                } = {}) {

        //fill attributes
        this.id=id;
        this.label=label;
        this.address=address;
        this.number=number;
        this.complement=complement;
        this.district=district;
        this.city=city;
        this.state=state;
        this.zipcode=zipcode;
        this.lat=lat;
        this.long=long;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

    }

}

export function createAddress(data={}) {
    return Object.freeze(new Address(data));
}